var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 131,
    viewBox: "0 0 130 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 78.1875C15.7909 78.1875 14 79.9784 14 82.1875V99.1875C14 103.053 17.134 106.188 21 106.188H28V78.1875H21H18Z",
    fill: "#E4E7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7817 29.9816C23.7817 27.5065 25.4869 25.5 27.5904 25.5H78.373C80.4765 25.5 82.1817 27.5065 82.1817 29.9816V98.6879C82.1817 104.688 80.4765 106.17 78.373 106.17H27.5904C26.4673 106.17 21 106.188 21 106.188C21 106.188 23.7817 106.179 23.7817 98.6879V29.9816Z",
    fill: "#F7F8FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2866 41.7266C40.2866 40.3243 41.4234 39.1875 42.8258 39.1875H64.4084C65.8107 39.1875 66.9475 40.3243 66.9475 41.7266C66.9475 43.129 65.8107 44.2658 64.4084 44.2658H42.8258C41.4234 44.2658 40.2866 43.129 40.2866 41.7266Z",
    fill: "#E4E7EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.478 51.8839C36.478 50.4815 37.6148 49.3447 39.0172 49.3447H68.2172C69.6195 49.3447 70.7563 50.4815 70.7563 51.8839C70.7563 53.2862 69.6195 54.423 68.2172 54.423H39.0172C37.6148 54.423 36.478 53.2862 36.478 51.8839Z",
    fill: "#E4E7EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.478 70.9268C36.478 69.5245 37.6148 68.3877 39.0172 68.3877H68.2172C69.6195 68.3877 70.7563 69.5245 70.7563 70.9268C70.7563 72.3291 69.6195 73.466 68.2172 73.466H39.0172C37.6148 73.466 36.478 72.3291 36.478 70.9268Z",
    fill: "#E4E7EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.478 90.9883C36.478 89.586 37.6148 88.4492 39.0172 88.4492H68.2172C69.6195 88.4492 70.7563 89.586 70.7563 90.9883C70.7563 92.3907 69.6195 93.5275 68.2172 93.5275H39.0172C37.6148 93.5275 36.478 92.3907 36.478 90.9883Z",
    fill: "#E4E7EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6694 60.7706C32.6694 59.3683 33.8062 58.2314 35.2086 58.2314H70.7564C72.1587 58.2314 73.2955 59.3683 73.2955 60.7706C73.2955 62.1729 72.1587 63.3097 70.7564 63.3097H35.2086C33.8062 63.3097 32.6694 62.1729 32.6694 60.7706Z",
    fill: "#E4E7EC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6694 81.0831C32.6694 79.6808 33.8062 78.5439 35.2086 78.5439H70.7564C72.1587 78.5439 73.2955 79.6808 73.2955 81.0831C73.2955 82.4854 72.1587 83.6222 70.7564 83.6222H35.2086C33.8062 83.6222 32.6694 82.4854 32.6694 81.0831Z",
    fill: "#E4E7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9735 58.7567C90.9735 70.6742 81.3124 80.3353 69.3948 80.3353C57.4773 80.3353 47.8162 70.6742 47.8162 58.7567C47.8162 46.8391 57.4773 37.178 69.3948 37.178C81.3124 37.178 90.9735 46.8391 90.9735 58.7567Z",
    fill: "#EDF6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5449 50.8058C45.5449 48.9241 47.0704 47.3987 48.9521 47.3987H69.9678C71.8495 47.3987 73.3749 48.9241 73.3749 50.8058C73.3749 52.6876 71.8495 54.213 69.9678 54.213H48.9521C47.0704 54.213 45.5449 52.6876 45.5449 50.8058Z",
    fill: "#4FA3F0",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5449 62.1642C45.5449 60.2825 47.0704 58.7571 48.9521 58.7571H73.7765C75.6582 58.7571 77.1836 60.2825 77.1836 62.1642C77.1836 64.046 75.6582 65.5714 73.7765 65.5714H48.9521C47.0704 65.5714 45.5449 64.046 45.5449 62.1642Z",
    fill: "#4FA3F0",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.001 74.0002C46.001 72.0672 47.3028 70.5002 48.9086 70.5002H70.0934C71.6992 70.5002 73.001 72.0672 73.001 74.0002C73.001 75.9332 71.6992 77.5002 70.0934 77.5002H48.9086C47.3028 77.5002 46.001 75.9332 46.001 74.0002Z",
    fill: "#4FA3F0",
    fillOpacity: 0.26
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.2463 86.3508C88.9561 85.0606 88.9561 82.9687 90.2463 81.6785L91.1808 80.744C92.4711 79.4538 94.5629 79.4538 95.8532 80.744L104.263 89.1543C105.554 90.4445 105.554 92.5364 104.263 93.8266L103.329 94.7611C102.039 96.0513 99.9468 96.0513 98.6566 94.7611L90.2463 86.3508Z",
    fill: "#4FA3F0"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2386 81.2123C82.4645 80.4381 82.4645 79.183 83.2386 78.4088L87.911 73.7365C88.6851 72.9623 89.9403 72.9623 90.7144 73.7365L94.9195 77.9416C95.6937 78.7157 95.6937 79.9709 94.9195 80.745L90.2472 85.4174C89.473 86.1915 88.2179 86.1915 87.4438 85.4174L83.2386 81.2123Z",
    fill: "#818692"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.3858 93.3585C94.6117 92.5844 94.6117 91.3292 95.3858 90.5551L100.058 85.8827C100.832 85.1086 102.087 85.1086 102.862 85.8827L115.01 98.0309C115.784 98.805 115.784 100.06 115.01 100.834L110.337 105.507C109.563 106.281 108.308 106.281 107.534 105.507L95.3858 93.3585Z",
    fill: "#818692"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.6513 59.3251C96.6513 74.6925 84.1935 87.1503 68.8261 87.1503C53.4587 87.1503 41.001 74.6925 41.001 59.3251C41.001 43.9577 53.4587 31.5 68.8261 31.5C84.1935 31.5 96.6513 43.9577 96.6513 59.3251ZM49.1266 59.3251C49.1266 70.2049 57.9464 79.0246 68.8261 79.0246C79.7059 79.0246 88.5256 70.2049 88.5256 59.3251C88.5256 48.4454 79.7059 39.6256 68.8261 39.6256C57.9464 39.6256 49.1266 48.4454 49.1266 59.3251Z",
    fill: "#4FA3F0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_818",
    x: 39.001,
    y: 31.5,
    width: 76.5894,
    height: 76.5872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.860937 0 0 0 0 0.916562 0 0 0 0 1 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1_818",
    x: 89.2786,
    y: 77.7764,
    width: 15.9526,
    height: 17.9524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1_818",
    x: 82.658,
    y: 71.1558,
    width: 12.8423,
    height: 14.8423,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1_818",
    x: 94.8052,
    y: 83.302,
    width: 20.7852,
    height: 22.7852,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_818"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1_818",
    x: 41.001,
    y: 28.5,
    width: 56.6504,
    height: 58.6504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLoading);
export default __webpack_public_path__ + "static/media/ic_loading.5f25ee3d721f37d90ad203a2dd8b8269.svg";
export { ForwardRef as ReactComponent };